<template>
  <div class="lang-switcher" :aria-label="$t('nav.switchLanguage')">
    <button
      :class="{ active: currentLang === 'pt-BR' }"
      @click="setLang('pt-BR')"
      type="button"
    >PT</button>
    <span class="lang-divider" aria-hidden="true">|</span>
    <button
      :class="{ active: currentLang === 'en' }"
      @click="setLang('en')"
      type="button"
    >EN</button>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      currentLang: localStorage.getItem('flipmemo_lang') || 'pt-BR',
    };
  },
  methods: {
    setLang(lang) {
      localStorage.setItem('flipmemo_lang', lang);
      this.$i18n.locale = lang;
      document.documentElement.lang = lang === 'en' ? 'en' : 'pt-BR';
      this.currentLang = lang;
    },
  },
};
</script>

<style scoped>
.lang-switcher {
  display: flex;
  align-items: center;
  gap: 4px;
}
.lang-switcher button {
  background: none;
  border: none;
  color: #94adc8;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 2px 4px;
  line-height: 1;
  transition: color 0.15s;
}
.lang-switcher button:hover {
  color: #7eb3ff;
}
.lang-switcher button.active {
  color: #7eb3ff;
  font-weight: 800;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.lang-divider {
  color: rgba(148, 173, 200, 0.4);
  font-size: 12px;
  line-height: 1;
  user-select: none;
}
</style>
